import React from 'react';

const ChatLoading = () => {
  return (
    <div className="flex justify-center items-center h-24">
      <div className="flex space-x-2">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-4 h-4 rounded-full bg-gradient-to-br from-teal-400 to-blue-500 shadow-lg"
            style={{
              animation: `morphDots 2s ease-in-out ${i * 0.3}s infinite`,
            }}
          ></div>
        ))}
      </div>
      <style jsx>{`
        @keyframes morphDots {
          0%, 100% {
            transform: scale(0.8) translateY(0px);
            opacity: 0.7;
          }
          50% {
            transform: scale(1.3) translateY(-10px);
            opacity: 1;
            box-shadow: 0 10px 20px rgba(59, 130, 246, 0.3);
          }
        }
      `}</style>
    </div>
  );
};

export default ChatLoading;